import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import googlePlayIcon from '../views/account/program/img/googleplay.png';
import appStoreIcon from '../views/account/program/img/appstore.png';

export default function MobileAppBanner({ onClose }) {
    const [isVisible, setIsVisible] = useState(true);
    const [isVerySmallScreen, setIsVerySmallScreen] = useState(false);

    // Detectar pantallas muy pequeñas
    useEffect(() => {
        const checkScreenSize = () => {
            setIsVerySmallScreen(window.innerWidth < 360);
        };
        
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Removemos la funcionalidad de cerrar ya que no queremos que se pueda quitar
    // const handleClose = () => {
    //     setIsVisible(false);
    //     if (onClose) {
    //         onClose();
    //     }
    // };

    const handleAppStoreClick = () => {
        window.open('https://apps.apple.com/us/app/mential/id6739008930', '_blank');
    };

    const handleGooglePlayClick = () => {
        window.open('https://play.google.com/store/apps/details?id=io.mential.app.twa', '_blank');
    };

    if (!isVisible) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: '56px', // Posicionar justo encima de la navegación móvil (sin espacio)
                left: 0,
                right: 0,
                zIndex: 1500, // Menor que AccountMenuMobile (2000) para no tapar la navegación
                background: 'linear-gradient(135deg, #0A243E 0%, #3248CA 50%, #FF6B35 100%)',
                backgroundSize: '200% 200%',
                animation: 'gradientShift 6s ease-in-out infinite',
                color: 'white',
                padding: { xs: '6px 12px', sm: '8px 16px' }, // Padding responsivo para pantallas pequeñas
                boxShadow: '0 -8px 32px rgba(10, 36, 62, 0.4), 0 0 20px rgba(50, 72, 202, 0.2)', // Sombra más elegante con glow
                display: { xs: 'block', md: 'none' }, // Solo en móviles
                borderTop: '2px solid rgba(255, 255, 255, 0.15)', // Borde más visible
                backdropFilter: 'blur(8px)', // Efecto de cristal sutil
                '@keyframes gradientShift': {
                    '0%': {
                        backgroundPosition: '0% 50%'
                    },
                    '50%': {
                        backgroundPosition: '100% 50%'
                    },
                    '100%': {
                        backgroundPosition: '0% 50%'
                    }
                }
            }}
        >
            {isVerySmallScreen ? (
                // Layout compacto para pantallas muy pequeñas
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography 
                            sx={{ 
                                fontFamily: 'Recoleta',
                                fontWeight: 600,
                                fontSize: '11px',
                                lineHeight: 1.1,
                                color: 'white !important',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                                letterSpacing: '0.5px'
                            }}
                        >
                            Descarga nuestra app
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 0.8, flexShrink: 0 }}>
                        <Box
                            sx={{
                                cursor: 'pointer',
                                borderRadius: '6px',
                                padding: '5px',
                                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                    border: '1px solid rgba(255, 255, 255, 0.5)',
                                    transform: 'scale(1.05)'
                                }
                            }}
                            onClick={handleAppStoreClick}
                        >
                            <img
                                src={appStoreIcon}
                                alt="App Store"
                                style={{
                                    height: '26px',
                                    borderRadius: '4px',
                                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                                }}
                            />
                        </Box>
                        <Box
                            sx={{
                                cursor: 'pointer',
                                borderRadius: '6px',
                                padding: '5px',
                                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                    border: '1px solid rgba(255, 255, 255, 0.5)',
                                    transform: 'scale(1.05)'
                                }
                            }}
                            onClick={handleGooglePlayClick}
                        >
                            <img
                                src={googlePlayIcon}
                                alt="Google Play"
                                style={{
                                    height: '26px',
                                    borderRadius: '4px',
                                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            ) : (
                // Layout normal para pantallas más grandes
                <Grid2 container spacing={0.5} alignItems="center">
                    {/* Contenido del banner - responsivo */}
                    <Grid2 item xs={12} sm={7}>
                        <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: 0.1,
                            textAlign: { xs: 'center', sm: 'left' },
                            mb: { xs: 0.5, sm: 0 }
                        }}>
                            <Typography 
                                sx={{ 
                                    fontFamily: 'Recoleta',
                                    fontWeight: 600,
                                    fontSize: { xs: '12px', sm: '13px' },
                                    lineHeight: 1.1,
                                    color: 'white !important',
                                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                                    letterSpacing: '0.5px'
                                }}
                            >
                                Descarga nuestra app
                            </Typography>
                        </Box>
                    </Grid2>

                    {/* Botones de descarga - responsivos */}
                    <Grid2 item xs={12} sm={5}>
                         <Box sx={{ 
                             display: 'flex', 
                             gap: { xs: 0.8, sm: 1 }, 
                             justifyContent: { xs: 'center', sm: 'flex-end' }, 
                             alignItems: 'center'
                         }}>
                             <Box
                                 sx={{
                                     position: 'relative',
                                     cursor: 'pointer',
                                     borderRadius: { xs: '6px', sm: '7px' },
                                     padding: { xs: '4px', sm: '6px' },
                                     backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                     border: '1px solid rgba(255, 255, 255, 0.3)',
                                     transition: 'all 0.3s ease',
                                     '&:hover': {
                                         transform: 'scale(1.05)',
                                         backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                         border: '1px solid rgba(255, 255, 255, 0.5)',
                                         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
                                     }
                                 }}
                                 onClick={handleAppStoreClick}
                             >
                                 <img
                                     src={appStoreIcon}
                                     alt="App Store"
                                     style={{
                                         height: '28px',
                                         borderRadius: '4px',
                                         filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                                     }}
                                 />
                             </Box>
                             <Box
                                 sx={{
                                     position: 'relative',
                                     cursor: 'pointer',
                                     borderRadius: { xs: '6px', sm: '7px' },
                                     padding: { xs: '4px', sm: '6px' },
                                     backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                     border: '1px solid rgba(255, 255, 255, 0.3)',
                                     transition: 'all 0.3s ease',
                                     '&:hover': {
                                         transform: 'scale(1.05)',
                                         backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                         border: '1px solid rgba(255, 255, 255, 0.5)',
                                         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
                                     }
                                 }}
                                 onClick={handleGooglePlayClick}
                             >
                                 <img
                                     src={googlePlayIcon}
                                     alt="Google Play"
                                     style={{
                                         height: '28px',
                                         borderRadius: '4px',
                                         filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                                     }}
                                 />
                             </Box>
                         </Box>
                    </Grid2>
                </Grid2>
            )}
        </Box>
    );
}
